
export default {
    name:"tooltip",
    props: ['tooltipMsg'],
    data() {
      return {
        show:false
      };
    },
    computed:{
      
    },
    methods: {
      
    },
  };